import React, { FC } from 'react'
import { Icon } from '@rsuite/icons'
import { IconProps } from '@rsuite/icons/lib/Icon'

const EditSvg = React.forwardRef<SVGSVGElement>((props, ref) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    ref={ref}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.16501 14.7069L15.3712 4.50067C15.6942 4.17776 15.709 3.71621 15.4648 3.47193L14.5295 2.53671C14.2853 2.29243 13.8237 2.30732 13.5008 2.63023L3.29458 12.8365L2.73345 15.268L5.16501 14.7069ZM16.306 5.43602L6.0344 15.7077C5.90188 15.8402 5.73478 15.9328 5.55216 15.9749L1.28028 16.9608C1.13627 16.994 1.0072 16.8649 1.04043 16.7209L2.02625 12.449C2.06839 12.2664 2.16101 12.0993 2.29353 11.9668L12.5652 1.69515C13.3916 0.868737 14.6896 0.826866 15.4644 1.60163L16.3996 2.53684C17.1743 3.3116 17.1325 4.60961 16.306 5.43602Z"
    />
  </svg>
))

const EditIcon: FC<IconProps> = (props) => (
  <Icon
    {...props}
    as={EditSvg}
  />
)

export default EditIcon
